import React from "react";

import "./PartizanOpenSelling.sass";

const renderSeatsIoTicket = (
  { currency, category: { label }, labels: { section, parent, own }, pricing },
  i
) => {
  const [area, side] = section.split("-");
  const price = pricing.price || null;

  return (
    <div key={i} className="partizan-open-selling__selected-tickets-item">
      <span className="partizan-open-selling__text-normal">
        {label} {area}, Row {parent} Seat {own} {side}
      </span>
      <span className="partizan-open-selling__text-bold">
        {price} {currency}
      </span>
    </div>
  );
};

const renderTicket = ({ name, price, currency, count }, i) => (
  <div key={i} className="partizan-open-selling__selected-tickets-item">
    <span className="partizan-open-selling__text-normal">{name}</span>
    <span className="partizan-open-selling__text-bold">
      {price * count} {currency}
    </span>
  </div>
);

export const SelectedTickets = ({
  tickets = [],
  currency,
  total,
  feeRate,
  hasSeats,
}) => {
  if (!tickets.length) {
    return (
      <div className="partizan-open-selling__empty-tickets">
        <img src="/images/img-empty-events.svg" alt="Select Ticket" />
        <p>
          {hasSeats
            ? "Select a ticket on the map"
            : "Add a ticket from the list"}
        </p>
      </div>
    );
  }

  const renderTickets = () => {
    switch (hasSeats) {
      case true:
        return tickets.map((ticket, i) =>
          renderSeatsIoTicket({ ...ticket, currency }, i)
        );
      case false:
        return tickets.map((ticket, i) =>
          renderTicket({ ...ticket, currency }, i)
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="partizan-open-selling__selected-tickets">
        <h4 className="partizan-open-selling__text-bold">Tickets</h4>
        {renderTickets()}
      </div>

      <div className="partizan-open-selling__total">
        <div>
          <span className="partizan-open-selling__text-bold-large">
            Administration fee:
          </span>
          <span className="partizan-open-selling__text-bold-large">
            {feeRate * 100}%
          </span>
        </div>

        <div>
          <span className="partizan-open-selling__text-bold-large">Total:</span>
          <span className="partizan-open-selling__text-bold-large">
            {total} {currency}
          </span>
        </div>
      </div>
    </>
  );
};
